import { useEffect, useState, useRef } from 'react';
import Swal from 'sweetalert2';

import { User } from '../../classess/user/user';
import { Role } from '../../classess/role/role';

import { GlobalFormats } from '../../classess/main/globalFormats';

import UserAddEdit from './UserAddEdit';
import {
    awaitDelayAsync, getProcessButtons, dataTableLanguaje, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj, getResponse,
    handleResponseMessageAsync, settings, styles, LoadingSection
} from '../../helpers/main';
import { UserService } from '../../services/users/UserService';
import { RoleService } from '../../services/roles/RoleService';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { html, colors, icons, images, labels, messages, } = settings;

const currentMethod = 'Users';

export default function Users({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const dtUsersId = 'dtUsers';
    const [showData, setShowData] = useState(true);
    const isMount = useRef(true);
    const [process, setProcess] = useState({
        showLoading: true,
        add: false,
        edit: false,
        delete: false,
    });
    const [user, setUser] = useState({
        ...User?.getClass({}, false),
        passwordConfirm: '',
        roleId: '',
    });
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        showModal: false,
        typeModal: 0,
        languageObj: languageObj,
        dtUsersId: dtUsersId,
        dtUsersRowId: 0,
        roles: [Role?.class({}, false)],
    });
    const controls = {
        buttons: {
            addEditDetails: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAddEditDetails',
            },
            deleteUser: {
                defaultClass: 'btn btn-danger shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnDelete',
            },
        },
        icons: {
            addEditDetails: {
                id: 'iconAddEditDetails',
                defaultClass: icons?.fasFa?.plusCircle,
            },
            deleteUser: {
                id: 'iconDeleteUser',
                defaultClass: icons?.fasFa?.trash,
            },
        },
        spiners: {
            addEditDetails: {
                id: 'spAddEditDetails',
                defaultClass: '',
            }
        },
    };
    //#endregion variables

    //#region methods
    //#region users
    const getAddUser = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getAddUser';
        try {
            //#region variables
            let roles = [Role?.class({}, false)];
            //#endregion variables

            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, showLoading: true, add: true }));

            //#region roles (get users)
            response = await RoleService.getAllUsersAsync({
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            roles = response?.result?.roles;
            //#endregion roles (get users)

            setUser({
                ...User?.getClass({}, false),
                createdUserId: auth?.user?.id,
                passwordConfirm: '',
                roleId: '',
            });
            await awaitDelayAsync({ delayTime: settings?.timers?.twoNanoSeconds });

            setModalObj(prev => ({
                ...prev,
                $: $,
                type: 0,
                auth: auth,
                showModal: true,
                roles: roles,
            }));

        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false, add: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: auth,
                    languageId: languageObj?.id,
                    setShowData,
                    showDataValue: response?.isSuccess,
                });
            }
        }
    }

    const getEditUser = async ({
        e = {},
        id = '',
        description = '',
        rowId = '',
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getEditUser';
        try {
            //#region variables
            let userData = User?.getClass({}, false);
            //#endregion variables

            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, showLoading: true, edit: true }));

            //#region user (get byid)
            response = await UserService.getByIdWithCompaniesAsync({
                auth: auth,
                id: id,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            userData = !isUndNullEmp({ data: response?.result, subMethod: currentMethod })?.result &&
                !isUndNullEmp({ data: response?.result?.user, subMethod: currentMethod })?.result &&
                !isUndNull({ data: response?.result?.user?.id, subMethod: currentMethod })?.result ?
                User?.getClass(response?.result.user, false) :
                {};
            //#endregion user (get byid)

            //#region check data
            if (isUndNullEmp({ data: userData, subMethod: currentMethod })?.result) {
                response = getResponse({ type: 1 });
                response.msgText = `${messages?.theRecordCannotBeLocated[languageObj?.id]}<br/>${labels?.name?.[languageObj?.id]}: <b>${description}</b><br/>`;
                return;
            }
            //#endregion check data

            window.location.href = `${settings?.backend?.urls?.users}/${userData.id}`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false, edit: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: auth,
                    languageId: languageObj?.id,
                    setShowData,
                    showDataValue: response?.isSuccess,
                });
            }
        }
    }

    const deleteUser = async ({
        e = {},
        id = '',
        description = '',
        rowId = 0,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'deleteUser';
        try {
            e?.preventDefault?.();

            //#region show message
            const msgTextObj = {
                one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}`,
                two: `${labels?.user?.[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };
            const swalProperties = {
                icon: settings.react.sweetAlert2.messages.types.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                preConfirm: async () => {
                    Swal.getCancelButton().hidden = true;
                    Swal.update({
                        icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                        title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                        html: `${msgTextObj?.two}`,
                        showConfirmButton: false,
                    });
                    return await UserService.deleteAsync({
                        auth: auth,
                        id: id,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                },
            };

            const swalResult = await Swal.fire(swalProperties);
            //#endregion show message

            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;

                if (!response?.isSuccess || response?.isWarning) return;

                //#region delete datatable (user)
                $(`#${dtUsersId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);
                //#endregion delete datatable (user)

                response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
            } else {
                response = getResponse({ type: 0 });
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: auth,
                    languageId: languageObj?.id,
                    setShowData,
                    showDataValue: response?.isSuccess,
                });
            }
        }
        return response;
    }
    //#endregion users

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            //#region variables
            let users = [];
            //#endregion variables

            setShowData(true);
            setProcess(prev => ({ ...prev, showLoading: true }));

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region get data (users)
                response = await UserService.getAllNotAnalystsAsync({
                    auth: auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                users = response?.result.users;
                //#endregion get data (users)

                //#region set datatable
                if (!isUndNullEmp({ data: users, subMethod: currentMethod })?.result &&
                    users.length > 0) {
                    response = setDataInDataTable({ data: users, subMethod: currentMethod, });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                setShowData(false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: auth,
                    languageId: languageObj?.id,
                    setShowData,
                    showDataValue: response?.isSuccess,
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataTables';
        try {
            $(`#${dtUsersId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.email?.[languageObj?.id], width: '45%', },
                    { title: labels?.firstName?.[languageObj?.id], width: '25%', },
                    { title: labels?.lastName?.[languageObj?.id], width: '25%', },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtUsersId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setQueryCode';
        try {
            //#region process
            $(`#${dtUsersId} tbody`).on('click', 'tr', 'td', async function (e) {
                const rowId = getDtRowIndex({ dtId: dtUsersId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    const methodName = e?.target?.attributes?.method?.value || '';
                    const id_ = e?.target?.attributes?.id?.value || '';
                    const description = e?.target?.attributes?.description?.value || '';

                    switch (methodName) {
                        case 'edit':
                            getEditUser({ e: e, id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        case 'details':
                            break;
                        case 'delete':
                            deleteUser({ e: e, id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataInDataTable';
        try {
            //#region process
            const usersDt = [];

            data.forEach((user) => {
                const modelUser = User?.getClass(user, false);
                const processButtons = [];
                usersDt.push([
                    modelUser.email,
                    modelUser.firstName,
                    modelUser.lastName,
                    getProcessButtons({
                        id: modelUser.id,
                        description: modelUser.email,
                        showDetails: false,
                        labelDetails: labels?.details[languageObj?.id],
                        enabledDetails: false,
                        showDelete: true,
                        labelDelete: labels?.delete[languageObj?.id],
                        enabledDelete: true,
                        showEdit: true,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: true,
                        processButtons: processButtons,
                    })?.result,
                ]);
            });

            $(`#${dtUsersId}`)?.DataTable()?.rows?.add(usersDt)?.draw(true);
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods
    return (
        <div>
            <Menu viewName={settings?.app?.views?.settings?.settings} process={settings?.app?.views?.users?.users} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.users?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.users?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.users?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.user}></img>
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.users?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.users} mr-1`}></i> {labels?.index?.[languageObj?.id] || 'Maintenance'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className='ml-auto'>
                                                        <button id={controls?.buttons?.addEditDetails?.id}
                                                            type='button'
                                                            className={process?.add ? `${controls?.buttons?.addEditDetails?.defaultClass} ${settings?.react?.settings?.react?.html?.button?.classes?.disabled}` : controls?.buttons?.addEditDetails?.defaultClass}
                                                            title={labels?.add?.[languageObj?.id]}
                                                            disabled={process?.add || process?.edit || process?.delete}
                                                            onClick={(e) => getAddUser({ e: e, subMethod: controls?.buttons?.addEditDetails?.id })}
                                                            style={{ borderRadius: '5px' }}>
                                                            {process?.add ? (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                            ) : (
                                                                <i id={controls?.icons?.addEditDetails?.id} className={`${controls?.icons?.addEditDetails?.defaultClass}`} />
                                                            )} {labels?.add?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <TableIndex tableId={dtUsersId} languageObj={languageObj} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}

                    </div>
                </section>

            </div>

            {modalObj?.showModal && (
                <UserAddEdit modalObj={modalObj}
                    setModalObj={setModalObj}
                    user={user}
                    setUser={setUser} />
            )}
        </div>
    )
}